import { render, staticRenderFns } from "./history.html?vue&type=template&id=67b51af5&scoped=true&"
import script from "./history.js?vue&type=script&lang=js&"
export * from "./history.js?vue&type=script&lang=js&"
import style0 from "./history.scss?vue&type=style&index=0&id=67b51af5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b51af5",
  null
  
)

export default component.exports